// Addresses stored in customer metafield account.np_addresses as JSON array.
// Each address is either:
//   Nova Poshta:    { carrier: 'nova_poshta', label, deliveryType, cityRef, cityLabel,
//                     warehouseRef, warehouseLabel, streetRef, streetLabel, building,
//                     apartment, isDefault }
//   International:  { carrier: 'international', label, country, countryCode, city,
//                     address, zip, isDefault }

const NP_API = 'https://api.novaposhta.ua/v2.0/json/';
const NP_KEY = () => window.__SK_NP_API_KEY || '';

const POPULAR_CITIES = [
  { Present: 'Київ', DeliveryCity: 'e71f0bde-4370-11dd-9198-001d60451983' },
  { Present: 'Харків', DeliveryCity: 'db5c88d7-391c-11dd-90d9-001d60451983' },
  { Present: 'Одеса', DeliveryCity: 'db5c88e0-391c-11dd-90d9-001d60451983' },
  { Present: 'Дніпро', DeliveryCity: 'db5c88de-391c-11dd-90d9-001d60451983' },
  {
    Present: 'Запоріжжя',
    DeliveryCity: 'db5c88d9-391c-11dd-90d9-001d60451983',
  },
  { Present: 'Львів', DeliveryCity: 'db5c88da-391c-11dd-90d9-001d60451983' },
  { Present: 'Вінниця', DeliveryCity: 'db5c88dd-391c-11dd-90d9-001d60451983' },
  { Present: 'Полтава', DeliveryCity: 'db5c88df-391c-11dd-90d9-001d60451983' },
];

const WAREHOUSE_TYPE_REFS = {
  branch: [
    '841339c7-591a-42e2-8233-7a0a00f0ed6f', // Поштове відділення
    '9a68df70-0267-42a8-bb5c-37f427e36ee4', // Вантажне відділення
  ],
  postomat: ['f9316480-5f2d-425d-bc2c-ac7cd29decf0'],
};

function debounce(fn, ms) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), ms);
  };
}

async function npApi(modelName, calledMethod, methodProperties) {
  const res = await fetch(NP_API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      apiKey: NP_KEY(),
      modelName,
      calledMethod,
      methodProperties,
    }),
  });
  return res.json();
}

function escapeHtml(str) {
  const d = document.createElement('div');
  d.textContent = str || '';
  return d.innerHTML;
}

function showHint(dropdown, message) {
  dropdown.innerHTML = `<li class="checkout-dropdown__hint">${escapeHtml(message)}</li>`;
  dropdown.classList.remove('hidden');
}

let addresses = [];

document.addEventListener('DOMContentLoaded', async () => {
  await loadAddresses();
  document
    .getElementById('js-add-address')
    ?.addEventListener('click', addNewAddress);
});

async function loadAddresses() {
  const listEl = document.getElementById('js-addresses-list');
  try {
    const profile = await window.SKAuth.apiFetch('/api/customer/profile');
    addresses = profile.addresses || [];
    if (addresses.length && !addresses.some((a) => a.isDefault)) {
      addresses[0].isDefault = true;
    }
    renderAddressList();
  } catch (err) {
    listEl.innerHTML = `<p class="profile-msg profile-msg--error">${escapeHtml(err.message)}</p>`;
  }
}

function renderAddressList() {
  const listEl = document.getElementById('js-addresses-list');
  if (!addresses.length) {
    listEl.innerHTML = '<p class="profile-empty">Адрес доставки поки немає</p>';
    return;
  }
  listEl.innerHTML = addresses
    .map((addr, i) => renderAddressItem(addr, i))
    .join('');
  attachItemHandlers();
}

function renderAddressItem(addr, index) {
  const isDefault = !!addr.isDefault;
  const label =
    addr.label ||
    `Адреса ${index + 1}: ${addr.warehouseLabel || addr.streetLabel || addr.cityLabel || ''}`;
  return `
    <div class="address-item${isDefault ? ' is-default' : ''}" data-index="${index}">
      <div class="address-item__header js-address-header">
        <div class="address-item__radio"><div class="address-item__radio-dot"></div></div>
        <span class="address-item__label">${escapeHtml(label)}</span>
        <svg class="address-item__chevron" width="14" height="9" viewBox="0 0 14 9" fill="none">
          <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="address-item__body js-address-body"></div>
    </div>
  `;
}

function attachItemHandlers() {
  document.querySelectorAll('.address-item').forEach((item) => {
    const header = item.querySelector('.js-address-header');
    const body = item.querySelector('.js-address-body');
    const radioEl = item.querySelector('.address-item__radio');
    const index = parseInt(item.dataset.index);

    radioEl.addEventListener('click', async (e) => {
      e.stopPropagation();
      if (item.classList.contains('is-default')) return;
      addresses = addresses.map((addr, i) => ({
        ...addr,
        isDefault: i === index,
      }));
      await saveAddresses();
      renderAddressList();
    });

    header.addEventListener('click', () => {
      const wasOpen = item.classList.contains('is-expanded');
      document
        .querySelectorAll('.address-item')
        .forEach((i) => i.classList.remove('is-expanded'));
      if (!wasOpen) {
        item.classList.add('is-expanded');
        if (!body.hasChildNodes())
          mountAddressForm(body, addresses[index], index);
      }
    });
  });
}

function mountAddressForm(container, addr, index) {
  const tpl = document.getElementById('js-address-form-tpl');
  container.appendChild(tpl.content.cloneNode(true));

  const q = (s) => container.querySelector(s);

  const citySearch = q('.js-np-city-search');
  const cityDropdown = q('.js-np-city-dropdown');
  const cityRefEl = q('.js-np-city-ref');
  const cityNameEl = q('.js-np-city-name');

  const warehouseSearch = q('.js-np-warehouse-search');
  const warehouseDropdown = q('.js-np-warehouse-dropdown');
  const warehouseRefEl = q('.js-np-warehouse-ref');
  const warehouseNameEl = q('.js-np-warehouse-name');
  const warehouseField = q('.js-np-warehouse-field');

  const addressFields = q('.js-np-address-fields');
  const streetSearch = q('.js-np-street-search');
  const streetDropdown = q('.js-np-street-dropdown');
  const streetRefEl = q('.js-np-street-ref');
  const buildingEl = q('.js-np-building');
  const apartmentEl = q('.js-np-apartment');

  const npFieldsEl = q('.js-np-fields');
  const intlFieldsEl = q('.js-intl-fields');
  const intlCountryEl = q('.js-intl-country');
  const intlCityEl = q('.js-intl-city');
  const intlAddressEl = q('.js-intl-address');
  const intlZipEl = q('.js-intl-zip');
  const carrierRadios = container.querySelectorAll('.js-carrier-radio');

  const typeTabs = container.querySelectorAll('.js-np-type-tab');
  const saveBtn = q('.js-save-address');

  function selectedCarrier() {
    return (
      container.querySelector('.js-carrier-radio:checked')?.value ||
      'nova_poshta'
    );
  }

  function updateCarrierUI() {
    const isIntl = selectedCarrier() === 'international';
    npFieldsEl?.classList.toggle('hidden', isIntl);
    intlFieldsEl?.classList.toggle('hidden', !isIntl);
  }

  carrierRadios.forEach((radio) => {
    radio.addEventListener('change', updateCarrierUI);
  });

  let selectedCityRef = '';
  let currentType = 'branch';
  let cities = [],
    warehouses = [],
    streets = [];
  let initialCities = [];
  let cityRequestGen = 0;

  // ── Type UI ──────────────────────────────────────────────
  function updateTypeUI() {
    const isAddr = currentType === 'address';
    warehouseField?.classList.toggle('hidden', isAddr);
    addressFields?.classList.toggle('hidden', !isAddr);
    typeTabs.forEach((tab) => {
      tab
        .closest('.nova-poshta-tab')
        ?.classList.toggle('nova-poshta-tab--active', tab.checked);
    });
  }

  typeTabs.forEach((tab) => {
    tab.addEventListener('change', () => {
      currentType = tab.value;
      clearWarehouseSelection();
      warehouses = [];
      updateTypeUI();
      if (currentType !== 'address' && selectedCityRef) loadWarehouses();
    });
  });

  // ── Prefill ──────────────────────────────────────────────
  const isIntlAddr = addr?.carrier === 'international';
  carrierRadios.forEach((radio) => {
    radio.checked =
      radio.value === (isIntlAddr ? 'international' : 'nova_poshta');
  });
  updateCarrierUI();

  if (isIntlAddr) {
    if (intlCountryEl) intlCountryEl.value = addr.country || '';
    if (intlCityEl) intlCityEl.value = addr.city || '';
    if (intlAddressEl) intlAddressEl.value = addr.address || '';
    if (intlZipEl) intlZipEl.value = addr.zip || '';
    updateTypeUI();
  } else if (addr?.cityRef) {
    selectedCityRef = addr.cityRef;
    citySearch.value = addr.cityLabel || '';
    cityRefEl.value = addr.cityRef;
    cityNameEl.value = addr.cityLabel || '';
    currentType = addr.deliveryType || 'branch';
    typeTabs.forEach((tab) => {
      tab.checked = tab.value === currentType;
    });
    updateTypeUI();

    if (currentType !== 'address') {
      loadWarehouses().then(() => {
        if (addr.warehouseRef) {
          warehouseSearch.value = addr.warehouseLabel || '';
          warehouseRefEl.value = addr.warehouseRef;
          warehouseNameEl.value = addr.warehouseLabel || '';
        }
      });
    } else {
      if (streetSearch && addr.streetRef) {
        streetSearch.value = addr.streetLabel || '';
        streetRefEl.value = addr.streetRef;
      }
      if (buildingEl && addr.building) buildingEl.value = addr.building;
      if (apartmentEl && addr.apartment) apartmentEl.value = addr.apartment;
    }
  } else {
    updateTypeUI();
  }

  // ── City autocomplete ────────────────────────────────────
  async function showCityDropdown() {
    if (cities.length) {
      cityDropdown.classList.remove('hidden');
      return;
    }
    const gen = ++cityRequestGen;
    try {
      const data = await npApi('Address', 'getCities', {
        Limit: '20',
        Page: '1',
      });
      if (gen !== cityRequestGen) return;
      cities = (data.data || []).map((c) => ({
        Present: c.Description,
        DeliveryCity: c.Ref,
      }));
    } catch {
      if (gen !== cityRequestGen) return;
      cities = [...POPULAR_CITIES];
    }
    if (!cities.length) cities = [...POPULAR_CITIES];
    initialCities = cities;
    renderCityDropdown();
  }

  const searchCity = debounce(async (e) => {
    const query = e.target.value.trim();
    if (!query || query.length < 2) {
      if (initialCities.length) {
        cities = initialCities;
        renderCityDropdown();
      } else if (cities.length) cityDropdown.classList.remove('hidden');
      return;
    }
    const gen = ++cityRequestGen;
    try {
      const data = await npApi('AddressGeneral', 'searchSettlements', {
        CityName: query,
        Limit: '15',
        Page: '1',
      });
      if (gen !== cityRequestGen) return;
      const results = data.data?.[0]?.Addresses || [];
      if (results.length) {
        cities = results;
        renderCityDropdown();
      } else {
        const q = query.toLowerCase();
        const filtered = initialCities.filter((c) =>
          c.Present.toLowerCase().includes(q),
        );
        if (filtered.length) {
          cities = filtered;
          renderCityDropdown();
        } else showHint(cityDropdown, 'Нічого не знайдено');
      }
    } catch {
      /* ignore */
    }
  }, 300);

  function renderCityDropdown() {
    if (!cities.length) {
      cityDropdown.classList.add('hidden');
      return;
    }
    cityDropdown.innerHTML = cities
      .map((c, i) => `<li data-idx="${i}">${escapeHtml(c.Present)}</li>`)
      .join('');
    cityDropdown.classList.remove('hidden');
  }

  cityDropdown.addEventListener('click', (e) => {
    const li = e.target.closest('li[data-idx]');
    if (!li) return;
    const city = cities[+li.dataset.idx];
    if (!city) return;
    selectedCityRef = city.DeliveryCity;
    citySearch.value = city.Present;
    cityRefEl.value = city.DeliveryCity;
    cityNameEl.value = city.Present;
    cityDropdown.classList.add('hidden');
    clearWarehouseSelection();
    warehouses = [];
    if (currentType !== 'address') loadWarehouses();
  });

  citySearch.addEventListener('focus', showCityDropdown);
  citySearch.addEventListener('input', searchCity);

  // ── Warehouse autocomplete ───────────────────────────────
  function clearWarehouseSelection() {
    warehouseSearch.value = '';
    warehouseRefEl.value = '';
    warehouseNameEl.value = '';
  }

  async function loadWarehouses(searchQuery = '') {
    if (!selectedCityRef || currentType === 'address') return;
    const props = { CityRef: selectedCityRef, Limit: '200', Page: '1' };
    if (searchQuery) props.FindByString = searchQuery;
    try {
      const typeRefs = [].concat(WAREHOUSE_TYPE_REFS[currentType] || []);
      const responses = typeRefs.length
        ? await Promise.all(
            typeRefs.map((typeRef) =>
              npApi('Address', 'getWarehouses', {
                ...props,
                TypeOfWarehouseRef: typeRef,
              }),
            ),
          )
        : [await npApi('Address', 'getWarehouses', props)];

      const seenRefs = new Set();
      warehouses = responses
        .flatMap((data) => data.data || [])
        .filter((warehouse) => {
          if (!warehouse?.Ref || seenRefs.has(warehouse.Ref)) return false;
          seenRefs.add(warehouse.Ref);
          return true;
        });
      renderWarehouseDropdown();
    } catch {
      /* ignore */
    }
  }

  const searchWarehouse = debounce(async (e) => {
    const query = e.target.value.trim();
    if (!query && warehouses.length) {
      warehouseDropdown.classList.remove('hidden');
      return;
    }
    await loadWarehouses(query);
  }, 300);

  function showWarehouseDropdown() {
    if (warehouses.length) {
      warehouseDropdown.classList.remove('hidden');
    } else if (selectedCityRef) {
      showHint(warehouseDropdown, 'Завантаження...');
      loadWarehouses();
    } else {
      showHint(warehouseDropdown, 'Спочатку оберіть місто');
    }
  }

  function renderWarehouseDropdown() {
    if (!warehouses.length) {
      warehouseDropdown.classList.add('hidden');
      return;
    }
    warehouseDropdown.innerHTML = warehouses
      .map((w, i) => `<li data-idx="${i}">${escapeHtml(w.Description)}</li>`)
      .join('');
    warehouseDropdown.classList.remove('hidden');
  }

  warehouseDropdown.addEventListener('click', (e) => {
    const li = e.target.closest('li[data-idx]');
    if (!li) return;
    const wh = warehouses[+li.dataset.idx];
    if (!wh) return;
    warehouseSearch.value = wh.Description;
    warehouseRefEl.value = wh.Ref;
    warehouseNameEl.value = wh.Description;
    warehouseDropdown.classList.add('hidden');
  });

  warehouseSearch.addEventListener('focus', showWarehouseDropdown);
  warehouseSearch.addEventListener('input', searchWarehouse);

  // ── Street autocomplete ──────────────────────────────────
  if (streetSearch) {
    const searchStreet = debounce(async (e) => {
      const query = e.target.value.trim();
      if (!query || query.length < 2) {
        if (streets.length) streetDropdown.classList.remove('hidden');
        return;
      }
      if (!selectedCityRef) {
        showHint(streetDropdown, 'Спочатку оберіть місто');
        return;
      }
      try {
        const data = await npApi('Address', 'getStreet', {
          CityRef: selectedCityRef,
          FindByString: query,
          Limit: '15',
          Page: '1',
        });
        streets = data.data || [];
        if (streets.length) {
          streetDropdown.innerHTML = streets
            .map(
              (s, i) => `<li data-idx="${i}">${escapeHtml(s.Description)}</li>`,
            )
            .join('');
          streetDropdown.classList.remove('hidden');
        } else {
          showHint(streetDropdown, 'Нічого не знайдено');
        }
      } catch {
        /* ignore */
      }
    }, 300);

    streetSearch.addEventListener('focus', () => {
      if (streets.length) streetDropdown.classList.remove('hidden');
      else if (!selectedCityRef)
        showHint(streetDropdown, 'Спочатку оберіть місто');
    });
    streetSearch.addEventListener('input', searchStreet);

    streetDropdown.addEventListener('click', (e) => {
      const li = e.target.closest('li[data-idx]');
      if (!li) return;
      const s = streets[+li.dataset.idx];
      if (!s) return;
      streetSearch.value = s.Description;
      streetRefEl.value = s.Ref;
      streetDropdown.classList.add('hidden');
    });
  }

  // ── Outside click ────────────────────────────────────────
  const outsideClick = (e) => {
    if (!container.contains(e.target)) {
      cityDropdown.classList.add('hidden');
      warehouseDropdown.classList.add('hidden');
      if (streetDropdown) streetDropdown.classList.add('hidden');
    }
  };
  document.addEventListener('click', outsideClick);

  // ── Save ─────────────────────────────────────────────────
  saveBtn.addEventListener('click', async () => {
    const isDefault = addresses[index]?.isDefault || false;

    if (selectedCarrier() === 'international') {
      const country = intlCountryEl?.value.trim() || '';
      const city = intlCityEl?.value.trim() || '';
      const address = intlAddressEl?.value.trim() || '';
      const zip = intlZipEl?.value.trim() || '';

      if (!country) {
        window.SKAuth.showToast('Вкажіть країну', 'error');
        return;
      }
      if (!city) {
        window.SKAuth.showToast('Вкажіть місто', 'error');
        return;
      }
      if (!address) {
        window.SKAuth.showToast('Вкажіть адресу', 'error');
        return;
      }
      if (!zip) {
        window.SKAuth.showToast('Вкажіть поштовий індекс', 'error');
        return;
      }

      addresses[index] = {
        isDefault,
        carrier: 'international',
        country,
        city,
        address,
        zip,
        label: `Адреса ${index + 1}: ${address}, ${city}, ${country}`,
      };
    } else {
      if (!cityRefEl.value) {
        window.SKAuth.showToast('Оберіть місто', 'error');
        return;
      }
      if (currentType !== 'address' && !warehouseRefEl.value) {
        window.SKAuth.showToast('Оберіть відділення або поштомат', 'error');
        return;
      }
      if (currentType === 'address' && streetSearch && !streetRefEl.value) {
        window.SKAuth.showToast('Оберіть вулицю', 'error');
        return;
      }

      const warehouseLabel = warehouseNameEl.value;
      const streetLabel = streetSearch?.value || '';
      const building = buildingEl?.value || '';
      const cityLabel = cityNameEl.value;

      addresses[index] = {
        isDefault,
        carrier: 'nova_poshta',
        deliveryType: currentType,
        cityRef: cityRefEl.value,
        cityLabel,
        warehouseRef: warehouseRefEl.value,
        warehouseLabel,
        streetRef: streetRefEl?.value || '',
        streetLabel,
        building,
        apartment: apartmentEl?.value || '',
        label:
          currentType === 'address'
            ? `Адреса ${index + 1}: ${streetLabel} ${building}, ${cityLabel}`.trim()
            : `Адреса ${index + 1}: ${warehouseLabel}, ${cityLabel}`,
      };
    }

    await saveAddresses();
    document.removeEventListener('click', outsideClick);
    renderAddressList();
    window.SKAuth.showToast('Адресу збережено');
  });
}

function addNewAddress() {
  addresses.push({ isDefault: addresses.length === 0 });
  renderAddressList();
  const items = document.querySelectorAll('.address-item');
  if (items.length)
    items[items.length - 1].querySelector('.js-address-header').click();
}

async function saveAddresses() {
  await window.SKAuth.apiFetch('/api/customer/profile', {
    method: 'PUT',
    body: JSON.stringify({ addresses }),
  });
}
